import {Validator} from './Core/validator';

const setCaretPosition = (elem, caretPos) => {
    let range;
    if (elem.createTextRange) {
        range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
    } else {
        elem.focus();
        if (elem.selectionStart !== undefined) {
            elem.setSelectionRange(caretPos, caretPos);
        }
    }
};

const getCursorPosition = (element) => {
    let el = element;
    let pos = 0;
    if ('selectionStart' in element) {
        pos = element.selectionStart;
    } else if ('selection' in document) {
        element.focus();
        let Sel = document.selection.createRange();
        let SelLength = document.selection.createRange().text.length;
        Sel.moveStart('character', -el.value.length);
        pos = Sel.text.length - SelLength;
    }
    return pos;
};

const values = new Map();

const format = (targetInput, e) => {
    let tel = (targetInput.value).replace(/[^0-9]/g, '');

    if (!tel.length) {
        return;
    }
    let result = '';
    let position = getCursorPosition(targetInput);


    if (tel.length) {
        if (tel[0] === '3' || tel[0] === '4' || tel[0] === '9') {
            tel = '8' + tel;
        }
        if (tel[0] === '7') {
            result = '8';
        } else if (tel[0] === '8') {
            result = tel[0];
        } else {
            return;
        }

        result = result + ' (' + tel.substr(1, 3);
        if (tel.length > 3) {
            result = result + ') ' + tel.substr(4, 3);
        }
        if (tel.length > 6) {
            result = result + ' ' + tel.substr(7, 2);
        }
        if (tel.length > 9) {
            result = result + '-' + tel.substr(9, 2);
        }
    }

    targetInput.value = result;

    values.set(targetInput, result);

    if (e.keyCode === 46 || e.keyCode === 8) {
        setCaretPosition(targetInput, position);
    }
};

const getCurrentKey = (input) => {
    let currentKey = {
        key: '',
        isBackspace: false
    };

    let savedValue = '';
    if (values.has(input)) {
        savedValue = values.get(input);
    }

    let currentValues = input.value;

    if (currentValues.length > savedValue.length) {
        currentKey.key = currentValues.substr(savedValue.length);
    } else {
        currentKey.isBackspace = true;
    }

    values.set(input, currentValues);

    return currentKey;
};

const formatEvent = event => {
    let input = event.target;
    let currentKey = getCurrentKey(input);
    let inputValue = input.value;

    if (Validator.isNumber(currentKey.key) || !currentKey.isBackspace && inputValue.length) {
        format(event.currentTarget, event);
    }
};
export function phoneFormatter(selector) {
    if(!values.has(selector)) {
        selector.addEventListener('keyup', formatEvent);
    }
}
export function init() {
    document.querySelectorAll('input[type="tel"]').forEach(input => {
        phoneFormatter(input);
    });
}
